export enum ReportType {
  LICENSES = 'LICENSES',
  PERIOD = 'PERIOD',
  MONTHLY = 'MONTHLY',
  HISTORICAL = 'HISTORICAL',
  MONTHLY_LIVE_CLASSES = 'MONTHLY_LIVE_CLASSES',
  STUDY_PLAN = 'STUDY_PLAN',
  ACTIVITY_BY_PERIOD = 'ACTIVITY_BY_PERIOD',
}
